import { FONT_PRIMARY, FONT_SECONDARY } from "@/theme/typography";

export const accordionStyles = {
  "& .MuiAccordionSummary-content": {
    fontFamily: { xs: FONT_SECONDARY, md: FONT_PRIMARY },
    fontSize: { xs: "1rem !important", md: "1.125rem !important" },
    pr: { xs: 2, sm: 3, md: 4 },
  },
  "& .MuiAccordionDetails-root": {
    fontFamily: FONT_SECONDARY,
    fontSize: { xs: "0.87rem !important", md: "1.125rem !important" },
    fontWeight: 500,
  },
};
